import Config from "@/const/Config";
import { BaseOptionWithoutCode } from "@/types/Option";
import { BaseApi } from "@/api/BaseApi";
import { Buka } from "@/types/KoyouKeiyaku";
import { BukaDetail, DeleteBukaRes, GetBukaReq, UpsertBukaRes } from "@/types/MstBuka";

export class MstBukaApi extends BaseApi {

  /**
   * 全ての所属会社の部課を取得します（オプション値）
   */
  public async getAll(): Promise<Buka[]> {
    try {
      const res = await this.post<Buka[]>(Config.API_URL + '/buka/all', null);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 表示用の一覧を取得します
   */
  public async getList(cond?: GetBukaReq): Promise<BukaDetail[]> {
    try {
      const res = await this.post<BukaDetail[]>(Config.API_URL + '/master/buka/list', cond);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 表示用の詳細を取得します
   */
  public async getBukaDetail(bukaId: number): Promise<BukaDetail> {
    const req: GetBukaReq = {
      mst_buka_id: bukaId,
      buka_code: null,
      buka_name: null,
      buka_kana: null,
    }

    try {
      const res = await this.post<BukaDetail>(Config.API_URL + '/master/buka/detail', req);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }


  /**
   * 全ての所属会社の部課を取得します（オプション値）
   */
  public async getAllOptions(): Promise<BaseOptionWithoutCode[]> {
    try {
      const res = await this.post<BaseOptionWithoutCode[]>(Config.API_URL + '/buka/options/all', null);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 指定した所属会社の部課を取得します（オプション値）
   * @returns 指定した所属会社の部課一覧
   */
  public async getOptionsBySyozokuId(syozokuId: number): Promise<BaseOptionWithoutCode[]> {
    const req = {
      syozokuId: syozokuId,
    }
    try {
      const res = await this.post<BaseOptionWithoutCode[]>(Config.API_URL + '/buka/options/syozoku', req);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 部課の新規作成／更新
   */
  public async upsert(bukaDetail: BukaDetail) 
  {
    // バリデーションのチェック用
    // bukaDetail.syuugyou_basyos = null
    try {
      const res = await this.post<UpsertBukaRes>(Config.API_URL + '/master/buka/upsert', bukaDetail);
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }

  /**
   * 削除
   */
  public async deleteBuka(bukaId: number) {
    try {
      const res = await this.post<DeleteBukaRes>(Config.API_URL + '/master/buka/delete', { bukaId: bukaId });
      return res.data;
    } catch (e: any) {
      throw e;
    }
  }
}
